import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateSimplePopover} from '#core/application/modules/tiles/popover/index.js';

import ODDS_BOOST_BANNER from './odds-boost-banner.palette-schema.yaml';

registerTileSchema(ODDS_BOOST_BANNER);

export function generateOddsBoostBanner(TILE) {
    return {
        containerWrapper: {
            style: {
                maxHeight: 'initial',
            },
        },
        container: {
            base: {
                style: {
                    ...resolveBackground(TILE.ODDS_BOOSTS_CONTAINER_BG),
                    borderRadius: TILE.ODDS_BOOSTS_CONTAINER_BORDER_RADIUS,
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: TILE.ODDS_BOOSTS_CONTAINER_BORDER_COLOR,
                },
            },
            applied: {
                style: {
                    borderColor: TILE.ODDS_BOOSTS_CONTAINER_APPLIED_BORDER_COLOR,
                },
            },
        },
        betBuilderContainer: {
            base: {
                style: {
                    ...resolveBackground(TILE.ODDS_BOOSTS_BB_CONTAINER_BG),
                    borderRadius: TILE.ODDS_BOOSTS_CONTAINER_BORDER_RADIUS,
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: TILE.ODDS_BOOSTS_CONTAINER_BB_BORDER_COLOR,
                },
            },
            applied: {
                style: {
                    ...resolveBackground(TILE.ODDS_BOOSTS_BB_CONTAINER_BG),
                    borderColor: TILE.ODDS_BOOSTS_CONTAINER_APPLIED_BB_BORDER_COLOR,
                },
            },
        },
        boostIcon: {
            // a little bit confusing naming, for base we need to set styles only for APPLIED state and for all other states
            // we need to use disabled
            base: icon(TILE.ODDS_BOOSTS_APPLIED_ICON_COLOR),
            disabled: icon(TILE.ODDS_BOOSTS_ICON_COLOR),
        },
        title: {
            base: {
                style: TILE.ODDS_BOOSTS_TITLE_TEXT,
            },
            inUse: {
                style: TILE.ODDS_BOOSTS_IN_USE_TEXT,
            },
        },
        returnsText: {
            style: {
                ...TILE.ODDS_BOOSTS_RETURNS_TEXT,
            },
        },
        actionButton: {
            base: {
                style: {
                    base: TILE.ODDS_BOOSTS_ACTION_BUTTON_TEXT,
                    disabled: {
                        opacity: '0.5',
                    },
                },
            },
            available: {
                style: {
                    base: TILE.ODDS_BOOSTS_AVAILABLE_ACTION_BUTTON_TEXT,
                },
            },
        },
        infoTooltip: {
            infoButton: {
                buttonIcon: icon(TILE.ODDS_BOOSTS_INFO_ICON_COLOR, 'info'),
            },
            title: {
                style: TILE.ODDS_BOOSTS_POPOVER_TITLE_TEXT,
            },
            text: {
                style: TILE.ODDS_BOOSTS_POPOVER_DESCRIPTION_TEXT,
            },
            expiry: {
                style: TILE.ODDS_BOOSTS_POPOVER_EXPIRATION_TEXT,
            },
        },
        popover: {
            closeButton: {
                buttonIcon: icon(TILE.ODDS_BOOSTS_POPOVER_CLOSE_BUTTON.CLOSE_BUTTON_ICON_COLOR),
            },
            popup: generateSimplePopover(
                TILE.ODDS_BOOSTS_POPOVER_BG,
                TILE.ODDS_BOOSTS_POPOVER_BORDER_RADIUS,
                TILE.ODDS_BOOSTS_POPOVER_SHADOW,
                TILE.ODDS_BOOSTS_POPOVER_BORDER_COLOR
            ),
        },
    };
}
